import Lists from './lists';

export default Lists;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/plugins/lists/index.js